const InputField = ({
  label,
  name,
  value,
  onChange,
  type = 'text',
  required,
  placeholder,
  textarea,
  error,
  dir,
}) => (
  <div className="space-y-1.5">
    <label className="text-sm font-medium text-[#1F3D2B] block">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {textarea ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={4}
        dir={dir}
        className={`w-full bg-white border ${
          error ? 'border-red-500' : 'border-[#D8D2C8]'
        } rounded-xl px-4 py-3 text-sm text-[#1F3D2B] placeholder-[#92A082] focus:outline-none focus:ring-2 focus:ring-[#4A641F]/30 focus:border-[#4A641F] transition-all text-right leading-7`}
        data-testid={`input-${name}`}
      />
    ) : (
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        dir={dir}
        className={`w-full bg-white border ${
          error ? 'border-red-500' : 'border-[#D8D2C8]'
        } rounded-xl px-4 py-3 text-sm text-[#1F3D2B] placeholder-[#92A082] focus:outline-none focus:ring-2 focus:ring-[#4A641F]/30 focus:border-[#4A641F] transition-all text-right`}
        data-testid={`input-${name}`}
      />
    )}
    {error && <p className="text-red-500 text-xs">{error}</p>}
  </div>
);

export default InputField;
